import React from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  BlockquoteStyled,
  FigureStyled,
  QuotationStyled,
  SectionContainerStyled,
} from './styles';

export default () => {
  return (
    <SectionContainerStyled
      id='private-wealth-management-testimonial'
      backgroundVariant='darkDefault'
      themeType='darkTheme'>
      <Row align='center'>
        <Col
          xsmall={11}
          medium={10}
          align='center'>
          <AssistiveText component='h2'>
            Private Wealth Management Testimonial
          </AssistiveText>
          <FigureStyled>
            <BlockquoteStyled>
              <QuotationStyled />
              <Typography
                component='h3'
                nextElement='typography'
                themeType='darkTheme'
                branding='pcg'>
                Not only does my advisor focus on you when he meets with you, it&#39;s as if he has no <WidowBlock>other clients.</WidowBlock>
              </Typography>
            </BlockquoteStyled>
            <figcaption>
              <Typography
                nextElement='graphic'
                themeType='darkTheme'>
                &#8212; Joanne D., client of Symphony Financial, Private Client Group firm
              </Typography>
            </figcaption>
          </FigureStyled>
          <Typography
            component='small'
            themeType='darkTheme'
            disableBottomPadding>
            Testimonials may not be representative of the experience of other clients and are not a guarantee of future performance or success.
          </Typography>
        </Col>
      </Row>
    </SectionContainerStyled>
  );
};
